module.exports = {
  DomesticTrade: 'Внутренняя торговля',
  SiruiPleaseContactTheTroubleshooting: 'Не удалось отправить поручение Sirui. Свяжитесь с сотрудником для проверки:',
  OperationFailed: 'Ошибка операции',
  PleaseCheckTheData: 'Пожалуйста, отметьте данные',
  LockedContactAHigherUnlock: 'Заблокировано, печать невозможна. Обратитесь к руководителю для разблокировки!',
  AreCancelTheVoidingDocuments: 'Вы уверены, что хотите отменить аннулирование выбранных документов?',
  PleaseFormInvoiceEtcVoid: 'Сначала удалите подтверждение расходов, счета и т.д., затем аннулируйте.',
  PleaseFromTheMasterVoid: 'Удалите эту накладную из главного документа, затем аннулируйте.',
  PleaseFromThisMasterVoid: 'Удалите все накладные из этого главного документа, затем аннулируйте.',
  ThisThatRelevantDocumentsContinue: 'Данная операция будет отправлена на финансовую проверку. Перед отправкой подтвердите загрузку файлов в систему. Продолжить?',
  AttachmentContentIsTooLarge: 'Слишком большой объем вложения',
  ThereBillNumbersProfitPrinted: 'Есть зарубежные расходы без валидного номера счета. Печать анализа прибыли невозможна!',
  ThereBillNumbersProfitSubmitted: 'Есть зарубежные расходы без валидного номера счета. Отправка анализа прибыли невозможна!',
  LockedPrintedOrEDINeeded: 'Из-за превышения кредитного лимита документ заблокирован. Печать и EDI невозможны. Обратитесь к руководству для разблокировки!',
  PleaseTicketToBeAdded: 'Выберите накладные для добавления',
  AreCopyTheMastersInformation: 'Вы уверены, что хотите скопировать информацию о грузоотправителе/получателе из главного документа?',
  MasterPleaseMaintainTheFirst: 'Номер главного документа обязателен. Сначала укажите его.',
  PleaseTicketToBeEdited: 'Выберите накладные для редактирования',
  Add: 'Добавить',
  AirImportCargoOperationDetails: 'Детали операций по авиаимпорту',
  ThisAlreadyAFormalBusiness: 'Этот документ уже является официальной операцией.'
}
